import type { WorksheetModule, WorksheetSize } from "@arbeidsark/shared"
import range from "lodash/range"
import styled from "styled-components"
import MathematicsPageConfiguration from "./MathematicsPageConfiguration"

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1.15rem;
  gap: 1.15rem;

  padding-bottom: 3rem;
`

export interface MathematicsPageConfigurationListProps {
  numberOfPages: number
  pagesConfiguration?: Record<string, Record<string, WorksheetModule>>
  layout: WorksheetSize
  onPageModuleConfigurationChanged: (
    page: number,
    moduleNumber: number,
    moduleConfiguration: WorksheetModule,
  ) => void
  onRegenerateModule: (page: number, moduleNumber: number) => void
}

const MathematicsPageConfigurationList: React.FC<
  MathematicsPageConfigurationListProps
> = ({
  numberOfPages,
  pagesConfiguration,
  layout,
  onPageModuleConfigurationChanged,
  onRegenerateModule,
}) => {
  return (
    <Layout>
      {range(numberOfPages).map((page) => (
        <MathematicsPageConfiguration
          key={page}
          pageIndex={page}
          layout={layout}
          modulesConfiguration={pagesConfiguration?.[page]}
          onConfigurationChanged={(moduleIndex, configuration) => {
            onPageModuleConfigurationChanged(page, moduleIndex, configuration)
          }}
          onRegenerateModule={(moduleIndex) =>
            onRegenerateModule(page, moduleIndex)
          }
          isFirstPage={page === 0}
        />
      ))}
    </Layout>
  )
}

export default MathematicsPageConfigurationList
